import { FormattedMessage } from 'dibs-react-intl';

export const title = <FormattedMessage id="pdpRecentSales.title" defaultMessage="Recent Sales" />;

export const tooltip = (
    <FormattedMessage
        id="pdpRecentSales.tooltip"
        defaultMessage="We use creator, category, style, material, condition, color and item weight to determine item similarity. All sales data is made anonymous."
    />
);
